import React from "react";
import { useTranslation } from "react-i18next";
import "./footer.css";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Clinic Info */}
          <div className="footer-section">
            <h3 className="footer-title">{t("footer.clinicName")}</h3>
            <p className="footer-location">
              <i className="fas fa-map-marker-alt"></i>{" "}
              <a
                className="footer-address"
                href="https://www.google.com/maps/place/Dr+William+Mok+Orthodontic+Center/@22.2819611,114.1568384,750m/data=!3m2!1e3!4b1!4m6!3m5!1s0x34040064bd51fc75:0xf32c6d3ceb8cd52c!8m2!3d22.2819611!4d114.1568384!16s%2Fg%2F1xg5q8hr?entry=ttu&g_ep=EgoyMDI2MDEwNi4wIKXMDSoKLDEwMDc5MjA3M0gBUAM%3D"
              >
                {t("footer.location")}
              </a>
            </p>
            <div className="footer-links">
              <a className="footer-link" href="/weather">
                <i className="fas fa-cloud-rain"></i> {t("footer.weather")}
              </a>
              <a className="footer-link" href="/">
                <i className="fas fa-home"></i> {t("footer.home")}
              </a>
            </div>
          </div>

          {/* Contact Button */}
          <div className="footer-section">
            <h4 className="footer-subtitle">{t("footer.questions")}</h4>
            <a
              href={`tel:${t("footer.phoneNumber")}`}
              className="footer-button"
            >
              {t("footer.contactButton")}
            </a>
          </div>

          {/* Phone Number */}
          <div className="footer-section">
            <h4 className="footer-subtitle">{t("footer.callUs")}</h4>
            <a href={`tel:${t("footer.phoneNumber")}`} className="footer-phone">
              {t("footer.phoneNumber")}
            </a>
            <br />
            <a href="mailto:info@orthospecialist.hk" className="footer-phone">
              {t("footer.email")}
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} {t("footer.copyright")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
